import { useState } from 'react';
import { ReactComponent as LoadingSvg } from '../../assets/svg/loading-half-status.svg';
import request from '../../lib/request';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const value = String(e.target.value.trim());
    setEmail(value);
  };

  const sendNewPassword = async () => {
    try {
      if (!email) {
        throw new Error('Please enter your email.');
      }

      setLoading(true);
      const { result } = await request.post('/signin/reset-password', {
        email,
      });

      if (!result) {
        throw new Error('Failed to send a temporary password.');
      }

      alert(
        'A Temporary password has been sent to your email.\nPlease change the password after you sign in.'
      );
      window.location.href = '/signin';
    } catch (err) {
      alert(err?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex items-center justify-center min-h-screen bg-primary'>
      <div className='p-6 w-full max-w-sm'>
        <h2 className='text-2xl font-bold mb-6 text-center text-white'>
          Forgot your password?
        </h2>
        <div className='mb-12 space-y-4'>
          <input
            type='email'
            placeholder='Enter your email'
            onChange={handleInputChange}
            value={email}
            className='w-full bg-white rounded-full py-4 px-4 '
          />
          <button
            type='submit'
            className='w-full bg-accent py-4 rounded-full hover:bg-accent/80 transition duration-200 flex justify-center text-black font-bold'
            disabled={loading}
            onClick={sendNewPassword}
          >
            {loading ? (
              <LoadingSvg className='animate-spin' />
            ) : (
              'Request a new password'
            )}
          </button>
        </div>
        <div className='text-center text-white'>
          <p>
            Back to{' '}
            <a
              href='/signin'
              className='underline'
            >
              Sign In
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
